import styled from "styled-components";

const Title = styled.p`
  font-size: 4rem;
  weight: bold;
  text-align: center;
  margin-top: 25rem;
`;

export default Title;
